import jwt_decode from 'jwt-decode';
import Cookies from 'js-cookie';
import base64 from 'base-64';
import utf8 from 'utf8';

// return the user data from the session storage
export const getUser = () => {
  const userStr = Cookies.get('api_token');
  if (userStr) return JSON.parse(userStr);
  else return null;
};

// remove the token and user from the session storage
export const removeUserSession = () => {
  localStorage.clear();
  sessionStorage.clear();
  Cookies.remove('api_token');
  Cookies.remove('us_retailer_login_session');
  Cookies.remove('us_retailer_session');
  Cookies.remove('customer_details');
  Cookies.remove('isadduserpermission');
  localStorage.removeItem('isadduserpermission');
};
// set the token and user from the session storage
export const setUserSession = (user, expireTime) => {
  const token = JSON.stringify(user);
  const { exp } = jwt_decode(user);

  Cookies.set('api_token', token, {
    expires: new Date(exp * 1000),
    
  });
};

export const setTokenExpires = (user) => {
  localStorage.setItem('expiresAt', JSON.stringify(user));
};

export const setConfigLoginSucess = () => {
  sessionStorage.setItem('Login', true);
};
export const getConfigLoginSucess = () => {
  const status = sessionStorage.getItem('Login');
  if (status) return true;
  else return false;
};

export const getTokenExpires = () => {
  const expiresAt = localStorage.getItem('expires_in');
  if (expiresAt) return JSON.parse(expiresAt);
  else return null;
};

export const getMarqueeData = () => {
  const marquee = localStorage.getItem('topMarquee');
  if (marquee) return JSON.parse(marquee);
  else return null;
};

export const getBalanceData = () => {
  const CustomerBalance = localStorage.getItem('customer_balance');
  if (CustomerBalance) return JSON.parse(CustomerBalance);
  else return null;
};

export const getUserRole = () => {
  const decrypted = decryptToken();
  if (decrypted?.rle) return decrypted?.rle;
  else return null;
};

export const getUserName = () => {
  const decrypted = decryptToken();
  if (decrypted?.une) return decrypted?.une;
  else return null;
};

export const getUserID = () => {
  const decrypted = decryptToken();
  if (decrypted?.sub) return decrypted?.sub;
  else return null;
};

export const usRetailerSession = () => {
  const tkexp = decryptToken();
  if(tkexp?.exp) {
    Cookies.set('us_retailer_session', true, {
      expires: new Date(tkexp?.exp * 1000),
      
    });
  }
}

export const getusRetailerSession = () => {
  const retailerSession = Cookies.get('us_retailer_session');
  if (retailerSession) return JSON.parse(retailerSession);
  else return null;
};

export const usRetailerLoginSession = () => {
  const tkexp = decryptToken();
  if(tkexp?.exp) {
    Cookies.set('us_retailer_login_session', true, {
      expires: new Date(tkexp?.exp * 1000),
      
    });
  }
}

export const getusRetailerLoginSession = () => {
  const retailerSession = Cookies.get('us_retailer_login_session');
  if (retailerSession) return JSON.parse(retailerSession);
  else return null;
};

export const setCustomerNameSession = (firstName, lastName) => {
  const tkexp = decryptToken();
  if(tkexp?.exp) {
    Cookies.set('customer_details', JSON.stringify({firstName:firstName, lastName:lastName}), {
      expires: new Date(tkexp?.exp * 1000),
      
    });
  }
}

export const getCustomerNameSession = () => {
  const customerNameSession = Cookies.get('customer_details');
  
  if (customerNameSession) {
    let {firstName, lastName} = JSON.parse(customerNameSession);
    firstName = base64.decode(firstName);
    lastName =  base64.decode(lastName);
    return {firstName, lastName}
  }
  else return null;
};

export const setIsAddUserSession = (isAddUser) => {
  if (isAddUser !== undefined && isAddUser !== null && String(isAddUser) !== 'null') {
    localStorage.setItem('isadduserpermission', String(isAddUser));
    Cookies.set('isadduserpermission', String(isAddUser));
  } else {
    localStorage.removeItem('isadduserpermission');
    Cookies.remove('isadduserpermission');
  }
};

export const getIsAddUser = () => {
  const decrypted = decryptToken();
  if (decrypted?.isadduserpermission !== undefined && decrypted?.isadduserpermission !== null) {
    return Number(decrypted.isadduserpermission);
  }
  const cookieVal = Cookies.get('isadduserpermission');
  if (cookieVal !== undefined && cookieVal !== null && cookieVal !== '' && cookieVal !== 'null') {
    return Number(cookieVal);
  }
  const localVal = localStorage.getItem('isadduserpermission');
  if (localVal !== null && localVal !== undefined && localVal !== '' && localVal !== 'null') {
    return Number(localVal);
  }
  return null;
};


const decryptToken = () => {
  const token = getUser();
  if (token) {
    return jwt_decode(token);
  }
  return null;
};
